import { useState } from "react";
import Head from "next/head";
import useUser from "../lib/useUser";
import { Layout } from "../common/Layout";
import { Imgix, Hero, Section } from "../common/UI";
import withSession from "../lib/session";
import {
  Container,
  Grid,
  Button,
  Box,
  Divider,
  Typography,
} from "@mui/material";

import { Carousel } from "react-responsive-carousel";

export default function BikeAdventures({ user }) {
  return (
    <Layout>
      <Grid item>
        <Hero
          minHeight={400}
          bgImg="https://bigsurf1public-stage.imgix.net/public/33503c15-4d63-42e7-bbb0-b09ecc4b7b98.jpg?w=1200&fit=crop&crop=faces"
          bgPosition="center"
        >
          <Box sx={{}}>
            <Typography
              variant="h2"
              sx={{
                color: "white",
                textShadow: "0 1px 0 black",
                textAlign: "center",
              }}
            >
              Bike Adventures
            </Typography>
          </Box>
          <Box sx={{}}>
            <Typography
              variant="h4"
              sx={{
                color: "white",
                textShadow: "0 1px 0 black",
                textAlign: "center",
              }}
            >
              Fun for everyone in the family!
            </Typography>
            <br />
            <br />
            <Grid container spacing={3} justifyContent="center">
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  href="/book-biking"
                  sx={{ zIndex: 10 }}
                >
                  Adventures from $55
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="info"
                  href="tel:8312648008"
                  sx={{ zIndex: 10 }}
                >
                  Call Us! (831) 264-8008
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Hero>

        <br />
        <Section id="beginner">
          <Container>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <Typography variant="h3">Beginner</Typography>
                <p>
                  Experience this beginner level guided mountain bike tour. With
                  an introductory lesson to mountain biking including core
                  skills and fundamentals, your guide will lead you on a scenic
                  3-7 mile route tailored to your riding abilities. Meet us at
                  the trailhead! <br />
                  <br />- Bikes and helmets provided <br />- 2-hour guided tour{" "}
                  <br />- Breaks are taken as needed for photos, water and
                  snacks
                  <br />
                  <br />
                  <strong>
                    Skills focus: Shifting, balance, breaking, line choice and
                    beginner bike handling skills
                  </strong>
                </p>
                <p>
                  <Button variant="contained" fullWidth href="/book-biking">
                    Book Now
                  </Button>
                </p>
              </Grid>
              <Grid item md={6}>
                <Imgix
                  src="https://bigsurf1public-stage.imgix.net/public/ac56c353-2966-4b95-a23f-eec65472cf13.jpg"
                  // width={600}
                  height={400}
                  boxProps={{
                    sx: {
                      "> img": {
                        width: "100%",
                        boxShadow: "0px 5px 15px 15px rgba(165,165,165,0.38)",
                        borderRadius: "10px",
                      },
                    },
                  }}
                  imgixParams={{
                    fit: "crop",
                    crop: "focalpoint",
                    ar: "4:3",
                  }}
                />
              </Grid>
            </Grid>
          </Container>
        </Section>

        <br />
        <Divider />
        <br />

        <Section id="intermediate">
          <Container>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <Typography variant="h3">Intermediate</Typography>
                <p>
                  Experience this intermediate-level guided mountain bike tour.
                  Ideal for those with previous mountain biking experience and
                  looking to sharpen their skills. Ride with our skilled
                  instructors on an 8-15 mile route selected to match your
                  ability levels. Meet us at the trailhead!\\n- Bikes and
                  helmets provided
                  <br />- 2 or 3-hour guided tour
                  <br />
                  <br />- Breaks as needed for photos, water, and snacks <br />
                  <br />
                  <br />
                  <strong>
                    Skills focus: Line selection, cornering, speed, intermediate
                    bike handling skills
                  </strong>
                </p>
                <p>
                  <Button variant="contained" fullWidth href="/book-biking">
                    Book Now
                  </Button>
                </p>
                <br />
                <br />
              </Grid>
              <Grid item md={6}>
                <Imgix
                  src="https://bigsurf1public-stage.imgix.net/public/0138e730-e355-4ee8-8049-f6f30a6440e7.jpg"
                  // width={600}
                  height={400}
                  boxProps={{
                    sx: {
                      "> img": {
                        width: "100%",
                        boxShadow: "0px 5px 15px 15px rgba(165,165,165,0.38)",
                        borderRadius: "10px",
                      },
                    },
                  }}
                  imgixParams={{
                    fit: "crop",
                    crop: "focalpoint",
                    ar: "4:3",
                  }}
                />
              </Grid>
            </Grid>
          </Container>
        </Section>

        <br />
        <Divider />
        <br />

        <Section id="expert">
          <Container>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <Typography variant="h3">Expert</Typography>
                <p>
                  Experience this expert level guided mountain bike tour. Ideal
                  for those looking for a fast pace, high-intensity ride with
                  advanced skills coaching. Join this 15-25 mile guided tour
                  with jumps, downhill sections, and steep climbs. Meet us at
                  the trailhead!
                  <br />
                  <br />- Bikes and helmets provided
                  <br />- 2 or 3-hour guided tour
                  <br />
                  <br />- Breaks are taken as needed for photos, water, and
                  snacks <br />
                  <br />
                  <strong>
                    Skills focus: Endurance, line selection, cornering, speed,
                    advanced bike handling skills
                  </strong>
                </p>
                <p>
                  <Button variant="contained" fullWidth href="/book-biking">
                    Book Now
                  </Button>
                </p>
              </Grid>
              <Grid item md={6}>
                <Imgix
                  src="https://bigsurf1public-stage.imgix.net/public/39c1cb3a-860d-4b36-aeba-bc633727c14b.jpg"
                  // width={600}
                  height={400}
                  boxProps={{
                    sx: {
                      "> img": {
                        width: "100%",
                        boxShadow: "0px 5px 15px 15px rgba(165,165,165,0.38)",
                        borderRadius: "10px",
                      },
                    },
                  }}
                  imgixParams={{
                    fit: "crop",
                    crop: "focalpoint",
                    ar: "4:3",
                  }}
                />
              </Grid>
            </Grid>
          </Container>
        </Section>

        <br />
        <Divider />
        <br />

        <Container style={{ textAlign: "center" }}>
          <div>
            <video
              autoPlay
              loop
              muted
              playsInline
              controls
              style={{ width: "100%" }}
            >
              <source
                src="https://bigsurf1.s3-us-west-1.amazonaws.com/bike-home-480.m4v"
                type="video/mp4"
              />
            </video>
          </div>
        </Container>
        <br />
      </Grid>
    </Layout>
  );
}

export const getServerSideProps = withSession(async function ({ req, res }) {
  const user = req.session.get("user") ?? null;
  return {
    props: { user },
  };
});
